import React from "react";
import { Box, Text } from "@chakra-ui/react";

const BoardQualificationBadge = ({ board, qualification }) => {
  return (
    <Box
      display="flex" 
      width="276px"
      padding="10px 0"
      justifyContent="center"
      alignItems="center"
      gap="8px"
      borderRadius="45px"
      border="1px solid #E4E4E4"
      bg="#FFF"
    >
      <Text color="#0A0A0A" textAlign="center" fontSize="24px" fontWeight="500" lineHeight="normal">
        {board}
      </Text>
      <Box width="9px" height="9px" flexShrink={0} borderRadius="50%" bg="#9A58FC" />
      <Text color="#0A0A0A" textAlign="center" fontSize="24px" fontWeight="500" lineHeight="normal">
        {qualification}
      </Text>
    </Box>
  );
};

export default BoardQualificationBadge; 


